import React, { useState } from 'react';
import { ApiRequestError } from '@app-types/api';
import type { TokenRequest } from '@app-types/auth';
import './LoginView.less';

export interface LoginViewProps {
  onSubmit: (request: TokenRequest, remember: boolean) => Promise<void>;
}

const LoginView: React.FC<LoginViewProps> = ({ onSubmit }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!username.trim() || !password) {
      setError('ユーザー名とパスワードを入力してください。');
      return;
    }
    setError('');
    setIsLoading(true);
    try {
      await onSubmit({ username, password }, remember);
    } catch (caught) {
      const apiError = caught instanceof ApiRequestError ? caught : null;
      setError(apiError?.status === 401
        ? 'ユーザー名またはパスワードが正しくありません。'
        : 'サーバーエラーが発生しました。しばらくしてから再度お試しください。');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="login-view">
      <form className="login-view__card" onSubmit={handleSubmit} noValidate>
        <h1 className="login-view__title">eSmart ログイン</h1>
        <label className="login-view__field">ユーザー名
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" disabled={isLoading} />
        </label>
        <label className="login-view__field">パスワード
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" disabled={isLoading} />
        </label>
        <label className="login-view__remember">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} disabled={isLoading} /> ログイン状態を保持する
        </label>
        {error && <p className="login-view__error" role="alert">{error}</p>}
        <button className="login-view__submit" type="submit" disabled={isLoading}>{isLoading ? 'ログイン中…' : 'ログイン'}</button>
      </form>
    </main>
  );
};

export default LoginView;
